angular.module('bizmetryApp').controller('DatasourceDialogController',
  function ($scope, $http, $mdDialog, $timeout, CONFIG, DatasourceService, dialogService) {
    console.log("🗂️ DatasourceDialogController abierto");

    $scope.currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');
    $scope.datasources = [];
    $scope.pendingDeletes = {};

    // =====================================================
    // FILTERING & SORTING
    // =====================================================

    $scope.dsFilter = { search: '', type: 'ALL', status: 'ALL', sort: 'name_asc' };
    $scope.filteredDatasources = [];

    $scope.dsSortOptions = [
      { value: 'name_asc',     label: 'Name A → Z'        },
      { value: 'name_desc',    label: 'Name Z → A'        },
      { value: 'online_first', label: 'Online first'      },
      { value: 'offline_first',label: 'Offline first'     },
      { value: 'type_asc',     label: 'DB Type A → Z'     },
      { value: 'env_asc',      label: 'Environment A → Z' }
    ];

    function applyDatasourceFilters() {
      if (!$scope.datasources || $scope.datasources.length === 0) {
        $scope.filteredDatasources = $scope.datasources || [];
        return;
      }

      var search = ($scope.dsFilter.search || '').toLowerCase().trim();
      var type   = $scope.dsFilter.type   || 'ALL';
      var status = $scope.dsFilter.status || 'ALL';
      var sort   = $scope.dsFilter.sort   || 'name_asc';

      // --- Filter ---
      var result;
      if (!search && type === 'ALL' && status === 'ALL') {
        result = $scope.datasources.slice();
      } else {
        result = $scope.datasources.filter(function (item) {
          if (search) {
            var nameMatch = item.datasourceName        && item.datasourceName.toLowerCase().indexOf(search)        !== -1;
            var descMatch = item.datasourceDescription && item.datasourceDescription.toLowerCase().indexOf(search) !== -1;
            if (!nameMatch && !descMatch) return false;
          }
          if (type !== 'ALL' && (item.datasourceType || '').toUpperCase() !== type) return false;
          if (status === 'ONLINE'  && !item.isOnline) return false;
          if (status === 'OFFLINE' &&  item.isOnline) return false;
          return true;
        });
      }

      // --- Sort ---
      result.sort(function (a, b) {
        var nameCmp = (a.datasourceName || '').localeCompare(b.datasourceName || '');
        switch (sort) {
          case 'name_asc':     return nameCmp;
          case 'name_desc':    return -nameCmp;
          case 'online_first':
            if (a.isOnline !== b.isOnline) return a.isOnline ? -1 : 1;
            return nameCmp;
          case 'offline_first':
            if (a.isOnline !== b.isOnline) return a.isOnline ? 1 : -1;
            return nameCmp;
          case 'type_asc':
            var typeCmp = (a.datasourceType || '').localeCompare(b.datasourceType || '');
            return typeCmp !== 0 ? typeCmp : nameCmp;
          case 'env_asc':
            var envCmp = (a.environmentTypeName || '').localeCompare(b.environmentTypeName || '');
            return envCmp !== 0 ? envCmp : nameCmp;
          default:
            return nameCmp;
        }
      });

      $scope.filteredDatasources = result;
    }

    $scope.$watchCollection('datasources', function () {
      applyDatasourceFilters();
    });

    $scope.onDatasourceFilterChange = function () {
      applyDatasourceFilters();
    };

    var _searchTimer = null;
    $scope.debouncedDatasourceSearch = function () {
      if (_searchTimer) $timeout.cancel(_searchTimer);
      _searchTimer = $timeout(function () {
        applyDatasourceFilters();
      }, 250);
    };

    // =====================================================
    // LOAD DATASOURCES
    // =====================================================
    function loadDatasources() {
      DatasourceService.getDatasources($scope.currentUser.id)
        .then(function (data) {
          $scope.datasources = data;
          console.log("✅ Datasources cargados:", data);
        })
        .catch(function (error) {
          console.error("❌ Error al cargar datasources:", error);
        });
    }

    // =====================================================
    // SHOW REFERENCES DIALOG
    // =====================================================
    $scope.showReferences = function (ds, ev) {
      if (!ds.references || ds.references.length === 0) return;

      $mdDialog.show({
        templateUrl: 'home/main-menu/datasources/references/datasource-references-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        multiple: true,
        controller: function ($scope, $mdDialog, datasource, references) {
          $scope.datasource = datasource;
          $scope.references = references;
          $scope.close = function () { $mdDialog.hide(); };
        },
        locals: {
          datasource: ds,
          references: ds.references
        }
      });
    };

    // =====================================================
    // DELETE DATASOURCE - 2 STAGE SYSTEM
    // =====================================================
    $scope.confirmOrDelete = function (ds, event) {
      if (!ds || !ds.id) {
        console.warn("⚠️ Elemento inválido en confirmOrDelete:", ds);
        return;
      }

      if (ds.isDataSourceInUse) {
        console.warn("🚫 [DELETE GUARD] Datasource en uso por template publicado:", ds.datasourceName);
        return;
      }

      if (event) event.stopPropagation();

      const id = ds.id;

      if ($scope.pendingDeletes[id]) {
        console.log("🗑️ Segunda vez - mostrando modal de confirmación");

        var referencesHtml = '';
        if (ds.references && ds.references.length > 0) {
          var rows = ds.references.map(function (ref) {
            return `
                <tr>
                    <td style="padding: 8px 12px; font-size: 13px; color: #1E2A3A; border-bottom: 1px solid #EFF1F8;">
                        <span style="display: inline-flex; align-items: center; gap: 4px;
                                     background: #f0fdfa; color: #0d9488; border: 1px solid #99f6e4;
                                     padding: 2px 8px; border-radius: 8px; font-size: 12px; font-weight: 600;">
                            ${ref.profileName || '—'}
                        </span>
                    </td>
                    <td style="padding: 8px 12px; font-size: 13px; color: #1E2A3A; font-weight: 500; border-bottom: 1px solid #EFF1F8;">
                        ${ref.templateName || '—'}
                    </td>
                    <td style="padding: 8px 12px; border-bottom: 1px solid #EFF1F8;">
                        <span style="background: #F4F5FA; color: #2D3A52; padding: 2px 8px;
                                     border: 1px solid #BFC5D8;
                                     border-radius: 6px; font-size: 12px; font-weight: 700;
                                     font-family: 'JetBrains Mono', 'Courier New', monospace;">
                            v${ref.version}
                        </span>
                    </td>
                </tr>
            `;
          }).join('');

          referencesHtml = `
            <div style="margin: 16px 0 0 0;">
                <p style="margin: 0 0 10px 0; font-size: 13px; color: #92400E; font-weight: 600; display: flex; align-items: center; gap: 6px;">
                    <span style="font-size: 16px;">⚠️</span>
                    Proceeding will impact the following templates:
                </p>
                <div style="border: 1px solid #DDE2EF; border-radius: 8px; overflow: hidden;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <thead>
                            <tr style="background: #EFF1F8;">
                                <th style="padding: 8px 12px; text-align: left; font-size: 11px;
                                           font-weight: 700; color: #4B5878; text-transform: uppercase;
                                           letter-spacing: 0.5px; border-bottom: 2px solid #E2E5EF;">Profile</th>
                                <th style="padding: 8px 12px; text-align: left; font-size: 11px;
                                           font-weight: 700; color: #4B5878; text-transform: uppercase;
                                           letter-spacing: 0.5px; border-bottom: 2px solid #E2E5EF;">Template</th>
                                <th style="padding: 8px 12px; text-align: left; font-size: 11px;
                                           font-weight: 700; color: #4B5878; text-transform: uppercase;
                                           letter-spacing: 0.5px; border-bottom: 2px solid #E2E5EF;">Version</th>
                            </tr>
                        </thead>
                        <tbody>${rows}</tbody>
                    </table>
                </div>
            </div>
        `;
        }

        var confirmationMessage = `
        <p style="margin: 0 0 16px 0; font-size: 14px; color: #1E2A3A; line-height: 1.6;">
            Are you sure you want to delete the datasource:
        </p>
        <div style="background: #FEF2F2; border-left: 4px solid #DC2626;
                    padding: 12px 16px; border-radius: 6px; margin-bottom: 16px;">
            <strong style="font-size: 15px; color: #111827;">${ds.datasourceName}</strong>
        </div>
        ${referencesHtml}
        <p style="margin: 16px 0 0 0; font-size: 13px; color: #8E97B4; line-height: 1.5;">
            This action cannot be undone.
        </p>
    `;

        dialogService.showConfirmationDialog(
          'Delete Datasource',
          confirmationMessage,
          ds.datasourceName,
          true
        ).then(function (result) {

          if (result === 'confirmed') {
            console.log("✅ Usuario confirmó eliminación");
            delete $scope.pendingDeletes[id];

            $http({
              method: 'DELETE',
              url: CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry/datasource/' + id,
              headers: { 'X-User-Account-Id': $scope.currentUser.id }
            }).then(function () {
              console.log("✅ Datasource eliminado exitosamente:", id);
              loadDatasources();
            }).catch(function (error) {
              console.error("❌ Error al eliminar datasource:", error);

              var errorMessage = 'An unexpected error occurred while deleting the datasource.';
              if (error.data && error.data.message) {
                errorMessage = error.data.message;
              } else if (error.statusText) {
                errorMessage = error.statusText;
              }

              dialogService.showErrorDialog(
                'Delete Failed',
                dialogService.formatErrorMessage(error.data || {
                  error: 'Delete Error',
                  message: errorMessage,
                  path: '/v1/api/bizmetry/datasource/' + id,
                  timestamp: new Date().toISOString()
                })
              );
            });

          } else {
            console.log("ℹ️ Usuario canceló en el modal de confirmación");
            delete $scope.pendingDeletes[id];
          }
        });

      } else {
        console.log("⚠️ Primera vez - marcando como pendiente");
        $scope.pendingDeletes[id] = true;

        $timeout(function () {
          delete $scope.pendingDeletes[id];
        }, 3500);
      }
    };

    // =====================================================
    // CLOSE DIALOG
    // =====================================================
    $scope.closeDialog = function () {
      $mdDialog.hide();
    };

    // =====================================================
    // ADD DATASOURCE
    // =====================================================
    $scope.addDatasource = function (ev) {
      $mdDialog.show({
        controller: 'DatasourceEditDialogController',
        templateUrl: 'home/main-menu/datasources/edit-datasource/datasource-edit-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        fullscreen: false,
        multiple: true,
        locals: {
          datasource: null,
          isEdit: false,
          agents: $scope.onlineAgents
        }
      }).then(function (refresh) {
        if (refresh) loadDatasources();
      });
    };

    // =====================================================
    // EDIT DATASOURCE
    // =====================================================
    $scope.editDatasource = function (ds, ev) {
      if (ds.isDataSourceInUse) {
        console.warn("🚫 [EDIT GUARD] Datasource en uso por template publicado:", ds.datasourceName);
        return;
      }

      $mdDialog.show({
        controller: 'DatasourceEditDialogController',
        templateUrl: 'home/main-menu/datasources/edit-datasource/datasource-edit-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        escapeToClose: false,
        clickOutsideToClose: false,
        multiple: true,
        fullscreen: false,
        locals: {
          agents: $scope.onlineAgents,
          datasource: ds,
          isEdit: true
        }
      }).then(function (refresh) {
        if (refresh) loadDatasources();
      });
    };

    // =====================================================
    // UTILITY FUNCTIONS
    // =====================================================
    $scope.getOnlineCount = function () {
      return $scope.datasources.filter(function (ds) { return ds.isOnline; }).length;
    };

    $scope.getOfflineCount = function () {
      return $scope.datasources.filter(function (ds) { return !ds.isOnline; }).length;
    };

    $scope.getInUseCount = function () {
      return $scope.datasources.filter(function (ds) { return ds.isDataSourceInUse; }).length;
    };

    // BizMetry DS — environment type pill colors
    // All backgrounds are light navy/teal tints; text is always dark navy for legibility.
    var BM_ENV_PILL_COLORS = [
      { bg: '#f0fdfa', text: '#0d9488', border: '#99f6e4' },  /* teal-50/600/200 */
      { bg: '#F4F5FA', text: '#2D3A52', border: '#BFC5D8' },  /* navy-50/700/200 */
      { bg: '#EFF1F8', text: '#1E2A3A', border: '#C5CCDF' },  /* surface-3/navy-800/border-strong */
      { bg: '#ECFDF5', text: '#065F46', border: '#6EE7B7' },  /* success-bg/text/border */
      { bg: '#EFF6FF', text: '#1E40AF', border: '#BFDBFE' },  /* info-bg/text/border */
      { bg: '#FFFBEB', text: '#92400E', border: '#FCD34D' },  /* warning-bg/text/border */
      { bg: '#DDE2EF', text: '#1E2A3A', border: '#BFC5D8' },  /* navy-100/800/200 */
      { bg: '#f0fdfa', text: '#1E2A3A', border: '#14b8a6' },  /* teal-50 / navy-800 / teal-500 */
    ];

    $scope.getHashColor = function (type) {
      var label = typeof type === 'object' ? type.refObjectLabel : type;
      var hash = 0;
      for (var i = 0; i < label.length; i++) {
        hash = label.charCodeAt(i) + ((hash << 5) - hash);
      }
      return BM_ENV_PILL_COLORS[Math.abs(hash) % BM_ENV_PILL_COLORS.length].bg;
    };

    $scope.getTextColor = function (label) {
      var hash = 0;
      for (var i = 0; i < label.length; i++) {
        hash = label.charCodeAt(i) + ((hash << 5) - hash);
      }
      return BM_ENV_PILL_COLORS[Math.abs(hash) % BM_ENV_PILL_COLORS.length].text;
    };

    $scope.getBorderColor = function (label) {
      var hash = 0;
      for (var i = 0; i < label.length; i++) {
        hash = label.charCodeAt(i) + ((hash << 5) - hash);
      }
      return BM_ENV_PILL_COLORS[Math.abs(hash) % BM_ENV_PILL_COLORS.length].border;
    };

    // =====================================================
    // LOAD AGENTS FOR DATASOURCE CREATION
    // =====================================================
    $scope.hasOnlineAgents = false;

    function loadAgentsForDatasourceCreation() {
      DatasourceService.getReachableAgentsByAccount($scope.currentUser.id)
        .then(function (agents) {
          $scope.onlineAgents = agents;
          $scope.hasOnlineAgents = agents.length > 0;
          console.log('✅ REACHABLE agents=', $scope.onlineAgents);
        })
        .catch(function (err) {
          console.error('❌ Error fetching online agents:', err);
          $scope.onlineAgents = [];
          $scope.hasOnlineAgents = false;
        });
    }

    // =====================================================
    // INITIALIZATION
    // =====================================================
    loadDatasources();
    loadAgentsForDatasourceCreation();

    $scope.openDataExplorer = function (ds, ev) {
      if (!ds.isOnline) return;
      $mdDialog.show({
        controller: 'DataExplorerDialogController',
        templateUrl: 'home/main-menu/data-explorer/data-explorer-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: true,
        multiple: true,
        locals: { datasource: ds }
      });
    };
  });